import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'sex_gender_referenced_not_line_legal_requirements'

export const dataPointDefinition = {
  retracedId: 'sex_gender_referenced_not_line_legal_requirements',
  name: 'Sex / Gender referenced and not in line with legal requirements',
  description:
    'This item also includes distinctions based on marital status or family responsibilities, if those distinctions are applied to one sex, or have a disproportionate impact on one sex. Workers with family responsibilities refers to men and women with responsibilities in relation to their dependent child',
  meta: {
    slcpMeta: {
      key: 'rh-dis-4',
      number: 'RH-DIS-2-2',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'rh-dis-4', version: '1.7.0', provider: 'slcp'}],
  sortingId: 34260,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
